import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US.js';
import zhCN from 'vant/lib/locale/lang/zh-CN.js';
export function Locals(a){
    if(a == 'en'){
        Locale.use('en', enUS);
    }else if(a == 'zhCH'){
        Locale.use(a, zhCN);
    }
}